exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating__item.current[data-v-04459791]{margin-bottom:20px;transform:scale(1.1);border:1px solid rgba(0,128,218,.8)}", ""]);

// exports
